<template>
    <form-row title="Title Company" :no_border="true" class="mt-6">
        <input-text
            class="w-full"
            name="title_company"
            :value="closing.title_company"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        closing: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
